import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fbfc3bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md-table-cell-loader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "4",
  ry: "4",
  width: "18",
  height: "18"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_content_loader, {
      viewBox: "0 0 18 18",
      speed: 1.2,
      primaryColor: "#dad9e3",
      secondaryColor: "#cecdd8"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["speed"])
  ]))
}